import {
  TableData,
  Table,
  TableColumns,
  Button,
  Modal,
  ButtonGroup,
  TextBox,
  Select,
  TablePagination,
  OptionInterface,
  IconTrash,
  IconUpload,
  ContextualMenu,
  OptionValue,
  Search,
  Group,
  SelectOption,
  Checkbox,
  Card,
  IconWarningAlt,
} from "@veneer/core";
import "../../assets/css/views/userManagement/userManagement.css";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { IGetUsersDto } from "../../models/dto/userManagementApi/IGetUsersDto";
import { RootState } from "../../app/store";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import UsersManagementService from "../../services/userManagementApi/usersManagement.service";
import { IGetSupervisorListDto } from "../../models/dto/userManagementApi/IGetSupervisorListDto";
import { IGetRolesListDto } from "../../models/dto/userManagementApi/IGetRolesListDto";
import { IGetCountriesListDto } from "../../models/dto/userManagementApi/IGetCountriesListDto";
import { IGetTimeListDto } from "../../models/dto/userManagementApi/IGetTimeListDto";
import { IGetPartnerListDto } from "../../models/dto/userManagementApi/IGetPartnerListDto";
import { IGetFundListDto } from "../../models/dto/userManagementApi/IGetFundListDto";
import { IGetStateListDto } from "../../models/dto/userManagementApi/IGetStateListDto";
import { IGetCityListDto } from "../../models/dto/userManagementApi/IGetCityListDto";
import { ModalMessageUser } from "./UserComponent/ModalMessageUser";
import dataListService from "../../services/generalApi/dataList.service";
import useSearchSelect from "./UserComponent/useSearchSelect";
import { RolesEnum } from "../../models/enum/RolesEnum";
import { PartnersEnum } from "../../models/enum/userManagementApi/PartnersEnum";
import { CategoriesEnum } from "../../models/enum/userManagementApi/CategoriesEnum";
import { CategoriesFundEnum } from "../../models/enum/userManagementApi/CategoriesFundEnum";
import { FundsEnum } from "../../models/enum/userManagementApi/FundsEnum";

interface IFormValues {
  Name: string;
  LastName: string;
  Country: number[];
  DocumentId: string;
  State: number[];
  City: number[];
  Role: number[];
  Time: number[];
  Categories: number[];
  PartnerPrint: number[];
  PartnerPC: number[];
  FundPrint: number[];
  FundPC: number[];
  FundHpPrint: number[];
  FundHpPC: number[];
  Phone: string;
  Email: string;
  Supervisor: number[];
  Coordinator: number[];
  CheckWeb: boolean;
  FeePC: number;
  FeePrint: number;
}

interface IOptions {
  Country: SelectOption[];
  State: SelectOption[];
  City: SelectOption[];
  Role: SelectOption[];
  Time: SelectOption[];
  Partner: SelectOption[];
  Fund: SelectOption[];
  FundHP: SelectOption[];
  Supervisor: SelectOption[];
  Coordinator: SelectOption[];
  Categories: SelectOption[];
  FilteredCountry: SelectOption[];
  FilteredState: SelectOption[];
  FilteredCity: SelectOption[];
  FilteredRole: SelectOption[];
  FilteredTime: SelectOption[];
  FilteredPartner: SelectOption[];
  FilteredFund: SelectOption[];
  FilteredFundHP: SelectOption[];
  FilteredSupervisor: SelectOption[];
  FilteredCoordinator: SelectOption[];
  FilteredCategories: SelectOption[];
}

interface SearchState {
  userID: string;
  name: string;
  lastName: string;
  countryName: string;
  numberID: string;
  stateName: string;
  cellPhone: string;
  city: string;
  roleName: string;
  email: string;
  timeByRole: string;
  category: string;
  partner: string;
  fund: string;
  fundHp: string;
  supervisorName: string;
  coordinatorName: string;
  checkWeb: string;
  feePC: string;
  feePrint: string;
}

export default function Users() {
  const [t] = useTranslation("global");
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState<TableData[]>([]);
  const [tableFilteredData, setTableFilteredData] = useState<TableData[]>([]);
  const [requireFundHP, setRequireFundHP] = useState<boolean>(false);
  const languageID: any = useSelector((state: RootState) => state.languageId);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [openCreate, setOpenCreate] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [openCreatedUserModal, setOpenCreatedUserModal] = useState(false);
  const [openUncreatedUserModal, setOpenUncreatedUserModal] = useState(false);
  const [openUpdatedUserModal, setOpenUpdatedUserModal] = useState(false);
  const [openNotUpdateUserModal, setOpenNotUpdateUserModal] = useState(false);
  const [openDeleteModal, setDeleteModal] = useState(false);
  const [valueUserDelete, setValueUserDelete] = useState<number>(0);
  const [isButtonValid, setIsButtonValid] = useState<boolean>(true);
  const [isButtonValidUpdate, setIsButtonValidUpdate] =
    useState<boolean>(false);
  const { handleSearch } = useSearchSelect();

  const initialValidation = {
    Name: true,
    LastName: true,
    Country: true,
    Document: true,
    State: true,
    City: true,
    Role: true,
    Categories: false,
    Time: false,
    PartnerPrint: false,
    PartnerPC: false,
    FundPrint: false,
    FundPC: false,
    FundHpPrint: false,
    FundHpPC: false,
    Phone: true,
    Email: true,
    Supervisor: true,
    Coordinador: true,
  };

  const initialForm = {
    CountryID: 0,
    RoleID: 0,
    Name: "",
    SupervisorID: 0,
    CoordinatorId: 0,
    LastName: "",
    NumberID: "",
    Phone: "",
    Email: "",
    TimeID: 0,
    CategoryID: 0,
    PartnerPrintID: 0,
    PartnerPCID: 0,
    FundPrintID: 0,
    FundPCID: 0,
    FundHpPrintID: 0,
    FundHpPCID: 0,
    CityID: 0,
    CheckWeb: false,
    CategoryFundID: 0,
    FeePC: 0,
    FeePrint: 0,
  };

  const initialFormValues: IFormValues = {
    Name: "",
    LastName: "",
    Country: [],
    DocumentId: "",
    State: [],
    City: [],
    Role: [],
    Time: [],
    Categories: [],
    PartnerPrint: [],
    FundPrint: [],
    FundHpPrint: [],
    PartnerPC: [],
    FundPC: [],
    FundHpPC: [],
    Phone: "",
    Email: "",
    Supervisor: [],
    Coordinator: [],
    CheckWeb: false,
    FeePC: 0,
    FeePrint: 0,
  };

  const initialOptions: IOptions = {
    Country: [],
    State: [],
    City: [],
    Role: [],
    Time: [],
    Partner: [],
    Fund: [],
    FundHP: [],
    Supervisor: [],
    Coordinator: [],
    Categories: [],
    FilteredCountry: [],
    FilteredState: [],
    FilteredCity: [],
    FilteredRole: [],
    FilteredTime: [],
    FilteredPartner: [],
    FilteredFund: [],
    FilteredFundHP: [],
    FilteredSupervisor: [],
    FilteredCoordinator: [],
    FilteredCategories: [],
  };

  const initialValuesSearch: SearchState = {
    userID: "",
    name: "",
    lastName: "",
    countryName: "",
    numberID: "",
    stateName: "",
    city: "",
    roleName: "",
    timeByRole: "",
    category: "",
    partner: "",
    fund: "",
    fundHp: "",
    cellPhone: "",
    email: "",
    supervisorName: "",
    coordinatorName: "",
    checkWeb: "",
    feePC: "",
    feePrint: "",
  };

  const [form, setForm] = useState({ ...initialForm });
  const [formValues, setFormValues] = useState({ ...initialFormValues });
  const [handleValidate, setHandleValidate] = useState({
    ...initialValidation,
  });
  const [valueSearch, setValueSearch] = useState<SearchState>({
    ...initialValuesSearch,
  });

  const [formUpdate, setFormUpdate] = useState({ ...initialForm, UserID: 0 });
  const [formValuesUpdate, setFormValuesUpdate] = useState({
    ...initialFormValues,
  });
  const [handleValidateUpdate, setHandleValidateUpdate] = useState({
    ...initialValidation,
  });

  const [optionSelect, setOptionSelect] = useState<IOptions>(initialOptions);

  const memoizedHandleValidate = useMemo(
    () => handleValidate,
    [handleValidate]
  );

  const memoizedHandleValidateUpdate = useMemo(
    () => handleValidateUpdate,
    [handleValidateUpdate]
  );

  const specialRoles = useMemo(
    () => [
      RolesEnum.Merchandiser,
      RolesEnum.Promoter,
      RolesEnum.Demoware,
      RolesEnum.Activators,
    ],
    []
  );
  const showFeeFields = (roleID: number) => specialRoles.includes(roleID);

  useEffect(() => {
    const hasAtLeastOneFalse = Object.values(memoizedHandleValidate).some(
      (value) => value === true
    );

    const roleID = form.RoleID;
    const feeSelected = formValues.FeePC === 1 || formValues.FeePrint === 1;
    const feeError = showFeeFields(roleID) && !feeSelected;

    setIsButtonValid(hasAtLeastOneFalse || feeError);
  }, [
    memoizedHandleValidate,
    formValues.FeePC,
    formValues.FeePrint,
    form.RoleID,
  ]);

  useEffect(() => {
    const hasAtLeastOneFalse = Object.values(memoizedHandleValidateUpdate).some(
      (value) => value === true
    );

    const roleID = formUpdate.RoleID;
    const feeSelected =
      Boolean(formValuesUpdate.FeePC) || Boolean(formValuesUpdate.FeePrint);
    const feeError = showFeeFields(roleID) && !feeSelected;

    setIsButtonValidUpdate(hasAtLeastOneFalse || feeError);
  }, [
    memoizedHandleValidateUpdate,
    formValuesUpdate.FeePC,
    formValuesUpdate.FeePrint,
    formUpdate.RoleID,
  ]);

  useEffect(() => {
    getUsers();
    getCountriesList();
    getRolesList();
    getTimeList();
    getAdvisorCategories();
    getPartnerList();
    getFundsHpList();
    getSupervisorList();
    getCoordinatorBySubRegion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageID]);

  const updateOptions = useCallback(
    (key: keyof IOptions, value: SelectOption[]) => {
      setOptionSelect((prevState) => ({
        ...prevState,
        [key]: value,
      }));
    },
    []
  );

  const handleFilterChange = (field: keyof SearchState, value: string) => {
    if (value === "") {
      resetSearch();
      setTableData(tableFilteredData);
      return;
    }
    setValueSearch((prevState) => {
      const updatedSearchValues: SearchState = {
        ...prevState,
        [field]: value,
      };

      (Object.keys(prevState) as (keyof SearchState)[]).forEach((key) => {
        if (key !== field) {
          updatedSearchValues[key] = "";
        }
      });

      return updatedSearchValues;
    });

    const lowerCaseValue = value.toLowerCase();
    const filterArray = tableFilteredData.filter((element: any) => {
      const elementValue = element[field]?.toString().toLowerCase() || "";
      return elementValue.includes(lowerCaseValue);
    });

    setTableData(filterArray);
  };

  const resetForm = () => {
    setFormValues({ ...initialFormValues });
    setForm({ ...initialForm });
    setFormValuesUpdate({ ...initialFormValues });
    setFormUpdate({ ...initialForm, UserID: 0 });
    setRequireFundHP(false);
  };

  const resetValid = () => {
    setHandleValidate({ ...initialValidation });
    setHandleValidateUpdate({ ...initialValidation });
  };

  const resetSearch = () => {
    setValueSearch({ ...initialValuesSearch });
  };

  const options: OptionInterface[] = [
    { value: 1, label: t("header.update"), icon: <IconUpload /> },
    { value: 2, label: t("header.delete"), icon: <IconTrash /> },
  ];

  const contextualMenu = (
    userID: number,
    countryId: number,
    countryName: string,
    stateId: number,
    stateName: string,
    cityId: number,
    city: string,
    roleId: number,
    roleName: string,
    timeByRoleId: number,
    timeByRole: string,
    partnerPrintId: number,
    partnerPrint: string,
    fundPrintId: number,
    fundPrint: string,
    fundHpPrintId: number,
    fundHpPrint: string,
    partnerPCId: number,
    partnerPC: string,
    fundPCId: number,
    fundPC: string,
    fundHpPCId: number,
    fundHpPC: string,
    categoryId: number,
    category: string,
    categoryFundId: number,
    name: string,
    lastName: string,
    numberID: string,
    cellPhone: string,
    email: string,
    supervisorId: number,
    supervisorName: string,
    coordinatorId: number,
    coordinatorName: string,
    checkWeb: boolean,
    feePC: number,
    feePrint: number
  ) => (
    <ContextualMenu
      onClick={(e: any, option?: OptionInterface<OptionValue> | undefined) => {
        if (option?.value === 1) {
          resetForm();
          resetValid();
          setFormValuesUpdate((prevState) => ({ ...prevState, Name: name }));
          setFormValuesUpdate((prevState) => ({
            ...prevState,
            LastName: lastName,
          }));
          setFormValuesUpdate((prevState) => ({
            ...prevState,
            DocumentId: numberID,
          }));
          setFormValuesUpdate((prevState) => ({
            ...prevState,
            Phone: cellPhone,
          }));
          setFormValuesUpdate((prevState) => ({ ...prevState, Email: email }));
          setFormValuesUpdate((prevState) => ({
            ...prevState,
            CheckWeb: checkWeb,
          }));
          setFormValuesUpdate((prevState) => ({
            ...prevState,
            FeePC: feePC,
          }));
          setFormValuesUpdate((prevState) => ({
            ...prevState,
            FeePrint: feePrint,
          }));
          setHandleValidateUpdate((prevState) => ({
            ...prevState,
            Name: false,
          }));
          setHandleValidateUpdate((prevState) => ({
            ...prevState,
            LastName: false,
          }));
          setHandleValidateUpdate((prevState) => ({
            ...prevState,
            Document: false,
          }));
          setHandleValidateUpdate((prevState) => ({
            ...prevState,
            Phone: false,
          }));
          setHandleValidateUpdate((prevState) => ({
            ...prevState,
            Email: false,
          }));
          setHandleValidateUpdate((prevState) => ({
            ...prevState,
            Supervisor: false,
          }));
          setHandleValidateUpdate((prevState) => ({
            ...prevState,
            Coordinador: false,
          }));
          setHandleValidateUpdate((prevState) => ({
            ...prevState,
            Country: false,
          }));
          setHandleValidateUpdate((prevState) => ({
            ...prevState,
            State: false,
          }));
          setHandleValidateUpdate((prevState) => ({
            ...prevState,
            City: false,
          }));
          setHandleValidateUpdate((prevState) => ({
            ...prevState,
            Role: false,
          }));

          adaptOnChangeForSelect(roleId, roleName, onChangeRole);
          adaptOnChangeForSelect(countryId, countryName, onChangeCountry);
          adaptOnChangeForSelect(stateId, stateName, onChangeState);
          adaptOnChangeForSelect(cityId, city, onChangeCity);

          if (supervisorId !== 0) {
            adaptOnChangeForSelect(
              supervisorId,
              supervisorName,
              onChangeSupervisor
            );
          }
          if (coordinatorId !== 0) {
            adaptOnChangeForSelect(
              coordinatorId,
              coordinatorName,
              onChangeCoordinator
            );
          }
          if (timeByRoleId !== 0) {
            adaptOnChangeForSelect(timeByRoleId, timeByRole, onChangeTime);
          }
          if (categoryId !== 0) {
            adaptCategoryForSelect(categoryId, category);
          }
          if (partnerPrintId !== 0) {
            adaptPartnerForSelect(partnerPrintId, partnerPrint);
          }
          if (fundPrintId !== 0) {
            adaptOnChangeForSelect(fundPrintId, fundPrint, onChangeFundPrint);
          }
          if (fundHpPrintId !== 0) {
            adaptOnChangeForSelect(
              fundHpPrintId,
              fundHpPrint,
              onChangeFundHpPrint
            );
          }
          if (partnerPCId !== 0) {
            adaptOnChangeForSelect(partnerPCId, partnerPC, onChangePartnerPC);
          }
          if (fundPCId !== 0) {
            adaptOnChangeForSelect(fundPCId, fundPC, onChangeFundPC);
          }
          if (fundHpPCId !== 0) {
            adaptOnChangeForSelect(fundHpPCId, fundHpPC, onChangeFundHpPC);
          }

          const phoneFormat = cellPhone.replace(/\D/g, "");

          setFormUpdate({
            ...formUpdate,
            UserID: userID,
            CountryID: countryId,
            RoleID: roleId,
            SupervisorID: supervisorId,
            CoordinatorId: coordinatorId,
            Name: name,
            LastName: lastName,
            NumberID: numberID,
            Phone: phoneFormat,
            Email: email,
            TimeID: timeByRoleId,
            PartnerPrintID: partnerPrintId,
            FundPrintID: fundPrintId,
            FundHpPrintID: fundHpPrintId,
            PartnerPCID: partnerPCId,
            FundPCID: fundPCId,
            FundHpPCID: fundHpPCId,
            CategoryID: categoryId,
            CategoryFundID: categoryFundId,
            CityID: cityId,
            CheckWeb: checkWeb,
            FeePC: feePC,
            FeePrint: feePrint,
          });

          setOpenUpdate(true);
        } else if (option?.value === 2) {
          setValueUserDelete(0);
          setValueUserDelete(userID);
          setDeleteModal(true);
        }
      }}
      options={options}
    />
  );

  // Modal Create
  const changeHandlerName = (
    text: string,
    setFormValues: React.Dispatch<React.SetStateAction<any>>,
    setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
    setForm: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setFormValues((prevState: any) => ({ ...prevState, Name: text }));

    setHandleValidate((prevState: any) => ({
      ...prevState,
      Name: text === "" || /\d/.test(text.trim()),
    }));

    setForm((prevState: any) => ({
      ...prevState,
      Name: text,
    }));
  };

  const helperTextName = (formValues: any) => {
    let message = null;

    if (formValues.Name === "") {
      message = t("header.fieldEmpty");
    } else if (/\d/.test(formValues.Name.trim()) === true) {
      message = t("header.invalidCharacters");
    }

    return message;
  };

  const changeHandlerLastName = (
    text: string,
    setFormValues: React.Dispatch<React.SetStateAction<any>>,
    setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
    setForm: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setFormValues((prevState: any) => ({ ...prevState, LastName: text }));

    setHandleValidate((prevState: any) => ({
      ...prevState,
      LastName: text === "" || /\d/.test(text.trim()),
    }));

    setForm((prevState: any) => ({
      ...prevState,
      LastName: text,
    }));
  };

  const helperTextLastName = (formValues: any) => {
    let message = null;

    if (formValues.LastName === "") {
      message = t("header.fieldEmpty");
      return message;
    } else if (/\d/.test(formValues.LastName.trim()) === true) {
      message = t("header.invalidCharacters");
      return message;
    } else {
      return message;
    }
  };

  const changeHandlerDocumentID = (
    text: string,
    setFormValues: React.Dispatch<React.SetStateAction<any>>,
    setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
    setForm: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setFormValues((prevState: any) => ({ ...prevState, DocumentId: text }));

    setHandleValidate((prevState: any) => ({
      ...prevState,
      Document: text === "" || text.length <= 4,
    }));

    setForm((prevState: any) => ({
      ...prevState,
      NumberID: text,
    }));
  };

  const helperTextDocumentID = (formValues: any) => {
    let message = null;

    if (formValues.DocumentId === "") {
      message = t("header.fieldEmpty");
      return message;
    } else if (handleValidate.Document === true) {
      message = t("header.invalidDocument");
      return message;
    } else {
      return message;
    }
  };

  const changeHandlerPhone = (
    text: string,
    setFormValues: React.Dispatch<React.SetStateAction<any>>,
    setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
    setForm: React.Dispatch<React.SetStateAction<any>>
  ) => {
    const cleanedText = text.replace(/\D/g, "");
    let formatted = "";

    if (cleanedText.length <= 2) {
      formatted = `+(${cleanedText.slice(0, 2)}`;
    } else if (cleanedText.length <= 5) {
      formatted = `+(${cleanedText.slice(0, 2)}) ${cleanedText.slice(2, 5)}`;
    } else if (cleanedText.length <= 18) {
      formatted = `+(${cleanedText.slice(0, 2)}) ${cleanedText.slice(
        2,
        5
      )} - ${cleanedText.slice(5, 18)}`;
    }

    setHandleValidate((prevState: any) => ({
      ...prevState,
      Phone: formatted.length < 16,
    }));

    setFormValues((prevState: any) => ({ ...prevState, Phone: formatted }));
    setForm((prevState: any) => ({ ...prevState, Phone: cleanedText }));
  };

  const helperTexPhone = (formValues: any) => {
    let message = null;
    if (formValues.Phone === "") {
      message = t("header.fieldEmpty");
      return message;
    } else if (handleValidate.Phone === true) {
      message = t("header.example") + ": 57 322 1234567";
      return message;
    } else if (handleValidate.Phone === false) {
      return message;
    }
  };

  const changeHandlerEmail = (
    text: string,
    setFormValues: React.Dispatch<React.SetStateAction<any>>,
    setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
    setForm: React.Dispatch<React.SetStateAction<any>>
  ) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const isValidEmail = emailRegex.test(text);

    setHandleValidate((prevState: any) => ({
      ...prevState,
      Email: !isValidEmail,
    }));

    setFormValues((prevState: any) => ({ ...prevState, Email: text }));
    setForm((prevState: any) => ({ ...prevState, Email: text }));
  };

  const helperTexEmail = (formValues: any) => {
    let message = null;
    if (formValues.Email === "") {
      message = t("header.fieldEmpty");
      return message;
    } else if (handleValidate.Email === true) {
      message = t("header.fillEmail");
      return message;
    } else if (handleValidate.Email === false) {
      return message;
    }
  };

  const onChangeCountry = (
    selectedOption: SelectOption,
    setFormValues: React.Dispatch<React.SetStateAction<any>>,
    setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
    setForm: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setFormValues((prevState: any) => ({
      ...prevState,
      Country: [selectedOption.value],
      State: [],
      City: [],
    }));
    setForm((prevState: any) => ({
      ...prevState,
      CountryID: selectedOption.value,
      CityID: 0,
    }));
    setHandleValidate((prevState: any) => ({
      ...prevState,
      Country: false,
      State: true,
      City: true,
    }));

    getStateList(Number(selectedOption.value));
  };

  const helperTextCountry = (handleValidate: any) => {
    let message = null;

    if (handleValidate.Country === true) {
      message = t("modal.SelectOption");
      return message;
    } else {
      return message;
    }
  };

  const onChangeState = (
    selectedOption: SelectOption,
    setFormValues: React.Dispatch<React.SetStateAction<any>>,
    setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
    setForm: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setFormValues((prevState: any) => ({
      ...prevState,
      State: [selectedOption.value],
      City: [],
    }));
    setHandleValidate((prevState: any) => ({
      ...prevState,
      State: false,
      City: true,
    }));

    getCityList(Number(selectedOption.value));
  };

  const helperTextState = (handleValidate: any) => {
    let message = null;

    if (handleValidate.State === true) {
      message = t("modal.SelectOption");
      return message;
    } else {
      return message;
    }
  };

  const onChangeCity = (
    selectedOption: SelectOption,
    setFormValues: React.Dispatch<React.SetStateAction<any>>,
    setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
    setForm: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setFormValues((prevState: any) => ({
      ...prevState,
      City: [selectedOption.value],
    }));
    setForm((prevState: any) => ({
      ...prevState,
      CityID: selectedOption.value,
    }));
    setHandleValidate((prevState: any) => ({
      ...prevState,
      City: false,
    }));
  };

  const helperTextCity = (handleValidate: any) => {
    let message = null;

    if (handleValidate.City === true) {
      message = t("modal.SelectOption");
      return message;
    } else {
      return message;
    }
  };

  const onChangeRole = (
    selectedOption: SelectOption,
    setFormValues: React.Dispatch<React.SetStateAction<any>>,
    setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
    setForm: React.Dispatch<React.SetStateAction<any>>
  ) => {
    const requiredProductivityFields = !disableFieldsProductivity(
      selectedOption.value
    );

    setFormValues((prevState: any) => ({
      ...prevState,
      Role: [selectedOption.value],
      Supervisor: [],
      Coordinator: [],
      Time: [],
      Categories: [],
      PartnerPrint: [],
      FundPrint: [],
      FundHpPrint: [],
      PartnerPC: [],
      FundPC: [],
      FundHpPC: [],
    }));

    setForm((prevState: any) => ({
      ...prevState,
      RoleID: selectedOption.value,
      SupervisorID: 0,
      CoordinatorId: 0,
      TimeID: 0,
      CategoryID: 0,
      PartnerPrintID: 0,
      FundPrintID: 0,
      FundHpPrintID: 0,
      PartnerPCID: 0,
      FundPCID: 0,
      FundHpPCID: 0,
      CategoryFundID: 0,
    }));

    setHandleValidate((prevState: any) => ({
      ...prevState,
      Role: false,
      Supervisor:
        selectedOption.value === RolesEnum.Analista ||
        selectedOption.value === RolesEnum.Supervisor ||
        selectedOption.value === RolesEnum.VisualTrade ||
        selectedOption.value === RolesEnum.Entrenador ||
        selectedOption.value === RolesEnum.Coordinador ||
        selectedOption.value === RolesEnum.BackOffice ||
        selectedOption.value === RolesEnum.SupervisorDeConsulta
          ? false
          : true,
      Coordinador:
        selectedOption.value === RolesEnum.Supervisor ||
        selectedOption.value === RolesEnum.SupervisorDeConsulta,
      Time: requiredProductivityFields,
      Categories: requiredProductivityFields,
      PartnerPrint: false,
      FundPrint: false,
      FundHpPrint: false,
      PartnerPC: false,
      FundPC: false,
      FundHpPC: false,
    }));

    setRequireFundHP(false);
  };

  const helperTextRole = (handleValidate: any) => {
    let message = null;

    if (handleValidate.Role === true) {
      message = t("modal.SelectOption");
      return message;
    } else {
      return message;
    }
  };

  const onChangeTime = (
    selectedOption: SelectOption,
    setFormValues: React.Dispatch<React.SetStateAction<any>>,
    setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
    setForm: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setFormValues((prevState: any) => ({
      ...prevState,
      Time: [selectedOption.value],
    }));
    setForm((prevState: any) => ({
      ...prevState,
      TimeID: selectedOption.value,
    }));
    setHandleValidate((prevState: any) => ({
      ...prevState,
      Time: false,
    }));
  };

  const helperTexTime = (handleValidate: any) => {
    let message = null;

    if (handleValidate.Time === true) {
      message = t("modal.SelectOption");
      return message;
    } else {
      return message;
    }
  };

  const getFundList = useCallback(
    (
      partnerID: number,
      categoryFundID: number,
      callBack: (optionsFund: SelectOption[]) => void = () => {}
    ): void => {
      UsersManagementService.getFundList(partnerID, categoryFundID).then(
        (result: IGetFundListDto[]) => {
          const updatedOptions = result.map((item) => ({
            value: item.fundID,
            label: item.fund,
          }));

          updateOptions("Fund", updatedOptions);
          updateOptions("FilteredFund", updatedOptions);
          callBack(updatedOptions);
        }
      );
    },
    [updateOptions]
  );

  const setDefaultFundPrint = useCallback(
    (
      setFormValuesIn: React.Dispatch<React.SetStateAction<any>>,
      setHandleValidateIn: React.Dispatch<React.SetStateAction<any>>,
      setFormIn: React.Dispatch<React.SetStateAction<any>>,
      optionsFund: SelectOption[]
    ) => {
      // set fund HP by default
      const optionHP = optionsFund.find((p) => p.value === FundsEnum.HP);
      if (!optionHP) {
        return;
      }

      onChangeFundPrint(
        optionHP,
        setFormValuesIn,
        setHandleValidateIn,
        setFormIn
      );
    },
    []
  );

  const onChangePartnerPrint = useCallback(
    (
      selectedOption: SelectOption,
      setFormValuesIn: React.Dispatch<React.SetStateAction<any>>,
      setHandleValidateIn: React.Dispatch<React.SetStateAction<any>>,
      setFormIn: React.Dispatch<React.SetStateAction<any>>
    ) => {
      setFormValuesIn((prevState: any) => ({
        ...prevState,
        PartnerPrint: [selectedOption.value],
        FundPrint: [],
        FundHpPrint: [],
      }));
      setFormIn((prevState: any) => ({
        ...prevState,
        PartnerPrintID: selectedOption.value,
        FundPrintID: 0,
        FundHpPrintID: 0,
      }));
      setHandleValidateIn((prevState: any) => ({
        ...prevState,
        PartnerPrint: false,
        FundPrint: true,
      }));

      // sets callback for execute after of response of endpoint
      // that  get funds list by partner
      const callBack = (optionsFund: SelectOption[]) =>
        setDefaultFundPrint(
          setFormValuesIn,
          setHandleValidateIn,
          setFormIn,
          optionsFund
        );
      getFundList(
        Number(selectedOption.value),
        CategoriesFundEnum.Print,
        callBack
      );
    },
    [getFundList, setDefaultFundPrint]
  );

  const adaptPartnerForSelect = (id: number, name: string) => {
    const selectedOption = {
      value: id,
      label: name,
    };
    getFundList(Number(selectedOption.value), CategoriesFundEnum.Print);
    setFormValuesUpdate((prevState: any) => ({
      ...prevState,
      PartnerPrint: [selectedOption.value],
    }));
    setFormUpdate((prevState: any) => ({
      ...prevState,
      PartnerPrintID: selectedOption.value,
    }));
    setHandleValidateUpdate((prevState: any) => ({
      ...prevState,
      PartnerPrint: false,
    }));
  };

  const adaptCategoryForSelect = (id: number, name: string) => {
    const selectedOption = {
      value: id,
      label: name,
    };
    const requirePrintFund = categorySelectedApplyForPrintFund(
      Number(selectedOption.value)
    );
    const requirePCFund = categorySelectedApplyForPCFund(
      Number(selectedOption.value)
    );
    setFormValuesUpdate((prevState: any) => ({
      ...prevState,
      Categories: [selectedOption.value],
    }));
    setFormUpdate((prevState: any) => ({
      ...prevState,
      CategoryID: selectedOption.value,
      CategoryFundID: getCategoryFundID(requirePrintFund, requirePCFund),
    }));

    setHandleValidateUpdate((prevState: any) => ({
      ...prevState,
      Categories: false,
    }));
  };

  const onChangePartnerPC = useCallback(
    (
      selectedOption: SelectOption,
      setFormValues: React.Dispatch<React.SetStateAction<any>>,
      setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
      setForm: React.Dispatch<React.SetStateAction<any>>
    ) => {
      setFormValues((prevState: any) => ({
        ...prevState,
        PartnerPC: [selectedOption.value],
        FundPC: [],
        FundHpPC: [],
      }));
      setForm((prevState: any) => ({
        ...prevState,
        PartnerPCID: selectedOption.value,
        FundPCID: 0,
        FundHpPCID: 0,
      }));
      setHandleValidate((prevState: any) => ({
        ...prevState,
        PartnerPC: false,
        FundPC: true,
        FundHpPC: false,
      }));

      setRequireFundHP(false);
      getFundList(Number(selectedOption.value), CategoriesFundEnum.PC);
    },
    [getFundList]
  );

  const helperTextModal = (nothingSelected: boolean) => {
    let message = null;

    if (nothingSelected) {
      message = t("modal.SelectOption");
      return message;
    } else {
      return message;
    }
  };

  const onChangeFundPrint = (
    selectedOption: SelectOption,
    setFormValues: React.Dispatch<React.SetStateAction<any>>,
    setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
    setForm: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setFormValues((prevState: any) => ({
      ...prevState,
      FundPrint: [selectedOption.value],
      FundHpPrint: [],
    }));
    setForm((prevState: any) => ({
      ...prevState,
      FundPrintID: selectedOption.value,
      FundHpPrintID: 0,
    }));
    setHandleValidate((prevState: any) => ({
      ...prevState,
      FundPrint: false,
      FundHpPrint: validateRequireFundHP(selectedOption),
    }));

    setRequireFundHP(validateRequireFundHP(selectedOption));
  };

  const onChangeFundPC = (
    selectedOption: SelectOption,
    setFormValues: React.Dispatch<React.SetStateAction<any>>,
    setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
    setForm: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setFormValues((prevState: any) => ({
      ...prevState,
      FundPC: [selectedOption.value],
      FundHpPC: [],
    }));
    setForm((prevState: any) => ({
      ...prevState,
      FundPCID: selectedOption.value,
      FundHpPCID: 0,
    }));
    setHandleValidate((prevState: any) => ({
      ...prevState,
      FundPC: false,
      FundHpPC: validateRequireFundHP(selectedOption),
    }));

    setRequireFundHP(validateRequireFundHP(selectedOption));
  };

  const onChangeFundHpPrint = (
    selectedOption: SelectOption,
    setFormValues: React.Dispatch<React.SetStateAction<any>>,
    setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
    setForm: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setFormValues((prevState: any) => ({
      ...prevState,
      FundHpPrint: [selectedOption.value],
    }));
    setForm((prevState: any) => ({
      ...prevState,
      FundHpPrintID: selectedOption.value,
    }));
    setHandleValidate((prevState: any) => ({
      ...prevState,
      FundHpPrint: false,
    }));
  };

  const onChangeFundHpPC = (
    selectedOption: SelectOption,
    setFormValues: React.Dispatch<React.SetStateAction<any>>,
    setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
    setForm: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setFormValues((prevState: any) => ({
      ...prevState,
      FundHpPC: [selectedOption.value],
    }));
    setForm((prevState: any) => ({
      ...prevState,
      FundHpPCID: selectedOption.value,
    }));
    setHandleValidate((prevState: any) => ({
      ...prevState,
      FundHpPC: false,
    }));
  };

  const onChangeCategories = (
    selectedOption: SelectOption,
    setFormValuesIn: React.Dispatch<React.SetStateAction<any>>,
    setHandleValidateIn: React.Dispatch<React.SetStateAction<any>>,
    setFormIn: React.Dispatch<React.SetStateAction<any>>
  ) => {
    const requirePrintFund = categorySelectedApplyForPrintFund(
      Number(selectedOption.value)
    );
    const requirePCFund = categorySelectedApplyForPCFund(
      Number(selectedOption.value)
    );

    setFormValuesIn((prevState: any) => ({
      ...prevState,
      Categories: [selectedOption.value],
      PartnerPrint: [],
      FundPrint: [],
      FundHpPrint: [],
      PartnerPC: [],
      FundPC: [],
      FundHpPC: [],
    }));
    setFormIn((prevState: any) => ({
      ...prevState,
      CategoryID: selectedOption.value,
      PartnerPrintID: 0,
      FundPrintID: 0,
      FundHpPrintID: 0,
      PartnerPCID: 0,
      FundPCID: 0,
      FundHpPCID: 0,
      CategoryFundID: getCategoryFundID(requirePrintFund, requirePCFund),
    }));

    setHandleValidateIn((prevState: any) => ({
      ...prevState,
      Categories: false,
      PartnerPrint: requirePrintFund,
      FundPrint: requirePrintFund,
      FundHpPrint: requirePrintFund,
      PartnerPC: requirePCFund,
      FundPC: requirePCFund,
      FundHpPC: false,
    }));

    if (requirePrintFund) {
      setDefaultPartnerPrint(setFormValuesIn, setHandleValidateIn, setFormIn);
    }

    setRequireFundHP(false);
  };

  const getCategoryFundID = (isPrint: boolean, isPC: boolean): number => {
    if (isPrint && isPC) {
      return CategoriesFundEnum.Both;
    } else if (isPrint) {
      return CategoriesFundEnum.Print;
    } else if (isPC) {
      return CategoriesFundEnum.PC;
    } else {
      return 0;
    }
  };

  const onChangeSupervisor = (
    selectedOption: SelectOption,
    setFormValues: React.Dispatch<React.SetStateAction<any>>,
    setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
    setForm: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setFormValues((prevState: any) => ({
      ...prevState,
      Supervisor: [selectedOption.value],
      Coordinator: [],
    }));
    setForm((prevState: any) => ({
      ...prevState,
      SupervisorID: selectedOption.value,
      CoordinatorId: 0,
    }));

    if (selectedOption) {
      setHandleValidate((prevState: any) => ({
        ...prevState,
        Supervisor: false,
        Coordinador: false,
      }));
    }
  };

  const onChangeCoordinator = (
    selectedOption: SelectOption,
    setFormValues: React.Dispatch<React.SetStateAction<any>>,
    setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
    setForm: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setFormValues((prevState: any) => ({
      ...prevState,
      Coordinator: [selectedOption.value],
      Supervisor: [],
    }));
    setForm((prevState: any) => ({
      ...prevState,
      SupervisorID: 0,
      CoordinatorId: selectedOption.value,
    }));

    if (selectedOption) {
      setHandleValidate((prevState: any) => ({
        ...prevState,
        Coordinador: false,
      }));
    }
  };

  const helperTexSupervisor = (handleValidate: any) => {
    let message = null;

    if (handleValidate.Supervisor === true) {
      message = t("modal.SelectOption");
      return message;
    } else {
      return message;
    }
  };

  const disableSupervisor = (formValues: any) => {
    if (
      formValues.Role[0] === undefined ||
      formValues.Role[0] === RolesEnum.Analista ||
      formValues.Role[0] === RolesEnum.Supervisor ||
      formValues.Role[0] === RolesEnum.Coordinador ||
      formValues.Role[0] === RolesEnum.Entrenador ||
      formValues.Role[0] === RolesEnum.Coordinador ||
      formValues.Role[0] === RolesEnum.BackOffice ||
      formValues.Role[0] === RolesEnum.SupervisorDeConsulta
    ) {
      return true;
    } else {
      return false;
    }
  };

  const disableCoordinator = (formValues: any) => {
    if (
      formValues.Role[0] === RolesEnum.Supervisor ||
      formValues.Role[0] === RolesEnum.SupervisorDeConsulta
    ) {
      return false;
    } else {
      return true;
    }
  };

  const disablePartner = (formValues: IFormValues) => {
    if (
      formValues.Categories[0] === CategoriesEnum.DYP ||
      formValues.Categories[0] === CategoriesEnum.Supplies ||
      formValuesUpdate.Categories[0] === CategoriesEnum.DYP ||
      formValuesUpdate.Categories[0] === CategoriesEnum.Supplies
    ) {
      return true;
    } else {
      return false;
    }
  };

  const disableFieldsProductivity = useCallback(
    (roleID: any) => {
      return !specialRoles.includes(roleID);
    },
    [specialRoles]
  );

  const showFieldsTimeAndCategory = (roleID: number) => {
    return !disableFieldsProductivity(roleID);
  };

  const getSizeFieldPhoneNumber = (categorySelected: number): number => {
    let size = 6;

    if (categorySelected === 0) {
      return size;
    }
    if (categorySelectedApplyForPrintFund(categorySelected)) {
      size = 12;
    }
    if (categorySelectedApplyForPCFund(categorySelected) && requireFundHP) {
      size = 12;
    }
    if (categorySelectedApplyForPCFund(categorySelected) && !requireFundHP) {
      size = 6;
    }
    if (categorySelected === CategoriesEnum.PPS && requireFundHP) {
      size = 6;
    }
    if (categorySelected === CategoriesEnum.PPS && !requireFundHP) {
      size = 12;
    }

    return size;
  };

  const setDefaultPartnerPrint = useCallback(
    (
      setFormValues: React.Dispatch<React.SetStateAction<any>>,
      setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
      setForm: React.Dispatch<React.SetStateAction<any>>
    ) => {
      // set partner HP Exclusive by default

      const optionHP = optionSelect.Partner.find(
        (p) => p.value === PartnersEnum.HPExclusive
      );
      if (!optionHP) {
        return;
      }

      onChangePartnerPrint(optionHP, setFormValues, setHandleValidate, setForm);
    },
    [optionSelect, onChangePartnerPrint]
  );

  const validateRequireFundHP = useCallback(
    (_optionSelectFund: SelectOption) => {
      return (
        _optionSelectFund &&
        (_optionSelectFund.value === FundsEnum.HP ||
          _optionSelectFund.value === FundsEnum.CoSelling ||
          _optionSelectFund.value === FundsEnum.CMF1 ||
          _optionSelectFund.value === FundsEnum.CosellingPrint ||
          _optionSelectFund.value === FundsEnum.CMF1Print)
      );
    },
    []
  );

  const categorySelectedApplyForPrintFund = (
    categorySelected: number
  ): boolean => {
    return (
      categorySelected === CategoriesEnum.Supplies ||
      categorySelected === CategoriesEnum.Printing ||
      categorySelected === CategoriesEnum.DYP ||
      categorySelected === CategoriesEnum.PPS
    );
  };

  const categorySelectedApplyForPCFund = (
    categorySelected: number
  ): boolean => {
    return (
      categorySelected === CategoriesEnum.Computing ||
      categorySelected === CategoriesEnum.PPS
    );
  };

  const labelPrint = (label: string, categorySelected: number) => {
    if (categorySelected !== CategoriesEnum.PPS) return label;

    return `${label} (${t("header.printers")})`;
  };

  const labelPC = (label: string, categorySelected: number) => {
    if (categorySelected !== CategoriesEnum.PPS) return label;

    return `${label} (${t("header.computers")})`;
  };

  const labelFieldsFundsInTable = (
    labelPrint: string,
    labelPC: string,
    categoryFundID: number
  ) => {
    if (categoryFundID === 0) return "";
    if (categoryFundID === CategoriesFundEnum.Print) return labelPrint;
    if (categoryFundID === CategoriesFundEnum.PC) return labelPC;
    if (categoryFundID === CategoriesFundEnum.Both) {
      return `${t("header.printers")}: ${labelPrint};  ${t(
        "header.computers"
      )}: ${labelPC}`;
    }
  };

  const adaptOnChangeForSelect = (
    id: any,
    name: string,
    onChange: (
      selectedOption: SelectOption,
      setFormValues: React.Dispatch<React.SetStateAction<any>>,
      setHandleValidate: React.Dispatch<React.SetStateAction<any>>,
      setForm: React.Dispatch<React.SetStateAction<any>>
    ) => void
  ) => {
    const selectedOption = {
      value: id,
      label: name,
    };

    onChange(
      selectedOption,
      setFormValuesUpdate,
      setHandleValidate,
      setFormUpdate
    );
  };

  //request
  const getUsers = () => {
    setLoading(true);
    UsersManagementService.getUsers(languageID.value)
      .then((result: IGetUsersDto[]) => {
        fillData(result);
      })
      .finally(() => setLoading(false));
  };

  const submitHandlerCreate = () => {
    UsersManagementService.postCreateUser(form).then((result) => {
      closeModalCreate();
      if (result === 1) {
        openModalCreatedUser();
      } else {
        openModalUncreatedUser();
      }
    });
  };

  const submitHandlerUpdate = () => {
    UsersManagementService.putUpdateUser(formUpdate).then((result) => {
      closeModalUpdate();
      if (result === 1) {
        openModalUpdatedUser();
      } else {
        openModalNotUpdateUser();
      }
    });
  };

  const getSupervisorList = () => {
    UsersManagementService.getSupervisorList().then(
      (result: IGetSupervisorListDto[]) => {
        const updatedOptions = result.map((item) => ({
          value: item.userID,
          label: item.fullName,
        }));
        updateOptions("Supervisor", updatedOptions);
        updateOptions("FilteredSupervisor", updatedOptions);
      }
    );
  };

  const getRolesList = () => {
    UsersManagementService.getRolesList(languageID.value).then(
      (result: IGetRolesListDto[]) => {
        const updatedOptions = result.map((item) => ({
          value: item.roleId,
          label: item.name,
          description: item.description,
        }));
        updateOptions("Role", updatedOptions);
        updateOptions("FilteredRole", updatedOptions);
      }
    );
  };

  const getTimeList = () => {
    UsersManagementService.getTimeList(languageID.value).then(
      (result: IGetTimeListDto[]) => {
        const updatedOptions = result.map((item) => ({
          value: item.timeId,
          label: item.description,
        }));
        updateOptions("Time", updatedOptions);
        updateOptions("FilteredTime", updatedOptions);
      }
    );
  };

  const getPartnerList = () => {
    UsersManagementService.getPartnerList().then(
      (result: IGetPartnerListDto[]) => {
        const updatedOptions = result.map((item) => ({
          value: item.partnerId,
          label: item.name,
        }));
        updateOptions("Partner", updatedOptions);
        updateOptions("FilteredPartner", updatedOptions);
      }
    );
  };

  const getCountriesList = () => {
    UsersManagementService.getCountriesList().then(
      (result: IGetCountriesListDto[]) => {
        const updatedOptions = result.map((item) => ({
          value: item.contryId,
          label: item.countryName,
        }));
        updateOptions("Country", updatedOptions);
        updateOptions("FilteredCountry", updatedOptions);
      }
    );
  };

  const getStateList = (countryID: number) => {
    UsersManagementService.getStateList(countryID).then(
      (result: IGetStateListDto[]) => {
        const updatedOptions = result.map((item) => ({
          value: item.stateID,
          label: item.stateName,
        }));
        updateOptions("State", updatedOptions);
        updateOptions("FilteredState", updatedOptions);
      }
    );
  };

  const getCityList = (stateID: number) => {
    UsersManagementService.getCityList(stateID).then(
      (result: IGetCityListDto[]) => {
        const updatedOptions = result.map((item) => ({
          value: item.cityID,
          label: item.cityName,
        }));
        updateOptions("City", updatedOptions);
        updateOptions("FilteredCity", updatedOptions);
      }
    );
  };

  const getAdvisorCategories = () => {
    dataListService
      .getAdvisorCategories(languageID.value)
      .then((result: any[]) => {
        const updatedOptions = result.map((item) => ({
          value: item.categoryId,
          label: item.categoryName,
        }));
        updateOptions("Categories", updatedOptions);
        updateOptions("FilteredCategories", updatedOptions);
      });
  };

  const getFundsHpList = () => {
    dataListService.getFundsHP().then((result: any[]) => {
      const updatedOptions = result.map((item) => ({
        value: item.fundHpId,
        label: item.fundHpName,
      }));
      updateOptions("FundHP", updatedOptions);
      updateOptions("FilteredFundHP", updatedOptions);
    });
  };

  const deleteUser = (userID: number) => {
    UsersManagementService.putDeleteUser(userID).then((result) => {});
  };

  const getCoordinatorBySubRegion = () => {
    dataListService.getCoordinatorBySubRegion().then((result: any[]) => {
      const updatedOptions = result.map((item) => ({
        value: item.coordinatorId,
        label: item.fullName,
      }));
      updateOptions("Coordinator", updatedOptions);
      updateOptions("FilteredCoordinator", updatedOptions);
    });
  };

  //Tabla
  const fillData = (data: IGetUsersDto[]) => {
    const pagedData: TableData[] = [];
    for (let i = 0; i < data.length; i++) {
      const userManagement: IGetUsersDto = data[i];
      const tableData: TableData = {
        userID: userManagement.userID,
        countryName: userManagement.countryName,
        city: userManagement.city,
        roleName: userManagement.roleName,
        name: userManagement.name,
        lastName: userManagement.lastName,
        numberID: userManagement.numberID,
        cellPhone: userManagement.cellPhone,
        email: userManagement.email,
        supervisorName: userManagement.supervisorName,
        coordinatorName: userManagement.coordinatorName,
        checkWeb: userManagement.checkWeb ? t("header.yes") : t("header.no"),
        feePC: userManagement.feePC ? t("header.yes") : t("header.no"),
        feePrint: userManagement.feePrint ? t("header.yes") : t("header.no"),
        category: userManagement.category,
        timeByRole: userManagement.timeByRole,
        partner: labelFieldsFundsInTable(
          userManagement.partnerPrint,
          userManagement.partnerPC,
          userManagement.categoryFundId
        ),
        fund: labelFieldsFundsInTable(
          userManagement.fundPrint,
          userManagement.fundPC,
          userManagement.categoryFundId
        ),
        fundHp: labelFieldsFundsInTable(
          userManagement.fundHpPrint,
          userManagement.fundHpPC,
          userManagement.categoryFundId
        ),
        creationDate: userManagement.creationDate
          ? userManagement.creationDate
              .split("T")[0]
              .split("-")
              .reverse()
              .join("-")
          : null,
        modificationDate: userManagement.modificationDate
          ? userManagement.modificationDate
              .split("T")[0]
              .split("-")
              .reverse()
              .join("-")
          : null,
        rowConfig: {
          action: contextualMenu(
            userManagement.userID,
            userManagement.countryId,
            userManagement.countryName,
            userManagement.stateId,
            userManagement.stateName,
            userManagement.cityId,
            userManagement.city,
            userManagement.roleId,
            userManagement.roleName,
            userManagement.timeByRoleId,
            userManagement.timeByRole,
            userManagement.partnerPrintId,
            userManagement.partnerPrint,
            userManagement.fundPrintId,
            userManagement.fundPrint,
            userManagement.fundHpPrintId,
            userManagement.fundHpPrint,
            userManagement.partnerPCId,
            userManagement.partnerPC,
            userManagement.fundPCId,
            userManagement.fundPC,
            userManagement.fundHpPCId,
            userManagement.fundHpPC,
            userManagement.categoryId,
            userManagement.category,
            userManagement.categoryFundId,
            userManagement.name,
            userManagement.lastName,
            userManagement.numberID,
            userManagement.cellPhone,
            userManagement.email,
            userManagement.supervisorId,
            userManagement.supervisorName,
            userManagement.coordinatorId,
            userManagement.coordinatorName,
            userManagement.checkWeb,
            userManagement.feePC,
            userManagement.feePrint
          ),
          noWrap: false,
        },
      };
      pagedData.push(tableData);
    }
    setTableData(pagedData);
    setTableFilteredData(pagedData);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const columns: TableColumns[] = [
    {
      id: "userID",
      label: t("header.userId"),
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label={t("header.userId")}
            placeholder={`Buscar ${t("header.userId")}`}
            id={`table-filter`}
            onClear={() => {}}
            value={valueSearch.userID}
            onChange={(e) => handleFilterChange("userID", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "name",
      label: t("header.name"),
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label={t("header.name")}
            placeholder={`Buscar ${t("header.name")}`}
            id={`table-filter`}
            value={valueSearch.name}
            onClear={() => {}}
            onChange={(e) => handleFilterChange("name", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "lastName",
      label: t("header.lastName"),
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label={t("header.lastName")}
            placeholder={`Buscar ${t("header.lastName")}`}
            id={`table-filter`}
            value={valueSearch.lastName}
            onClear={() => {}}
            onChange={(e) => handleFilterChange("lastName", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "email",
      label: t("header.email"),
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label={t("header.email")}
            placeholder={`Buscar ${t("header.email")}`}
            id={`table-filter`}
            onClear={() => {}}
            value={valueSearch.email}
            onChange={(e) => handleFilterChange("email", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "roleName",
      label: t("header.role"),
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label={t("header.role")}
            placeholder={`Buscar ${t("header.role")}`}
            id={`table-filter`}
            onClear={() => {}}
            value={valueSearch.roleName}
            onChange={(e) => handleFilterChange("roleName", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "countryName",
      label: t("header.country"),
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label={t("header.country")}
            placeholder={`Buscar ${t("header.country")}`}
            id={`table-filter`}
            onClear={() => {}}
            value={valueSearch.countryName}
            onChange={(e) => handleFilterChange("countryName", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "city",
      label: t("header.city"),
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label={t("header.city")}
            placeholder={`Buscar ${t("header.city")}`}
            id={`table-filter`}
            onClear={() => {}}
            value={valueSearch.city}
            onChange={(e) => handleFilterChange("city", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "numberID",
      label: t("header.document"),
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label={t("header.document")}
            placeholder={`Buscar ${t("header.document")}`}
            id={`table-filter`}
            onClear={() => {}}
            value={valueSearch.numberID}
            onChange={(e) => handleFilterChange("numberID", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "cellPhone",
      label: t("header.phoneNumber"),
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label={t("header.phoneNumber")}
            placeholder={`Buscar ${t("header.phoneNumber")}`}
            id={`table-filter`}
            onClear={() => {}}
            value={valueSearch.cellPhone}
            onChange={(e) => handleFilterChange("cellPhone", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "supervisorName",
      label: t("header.supervisor"),
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label={t("header.supervisor")}
            placeholder={`Buscar ${t("header.supervisor")}`}
            id={`table-filter`}
            onClear={() => {}}
            value={valueSearch.supervisorName}
            onChange={(e) =>
              handleFilterChange("supervisorName", e!.toString())
            }
          />
        </div>
      ),
    },
    {
      id: "coordinatorName",
      label: t("header.coordinator"),
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label={t("header.coordinator")}
            placeholder={`Buscar ${t("header.coordinator")}`}
            id={`table-filter`}
            onClear={() => {}}
            value={valueSearch.coordinatorName}
            onChange={(e) =>
              handleFilterChange("coordinatorName", e!.toString())
            }
          />
        </div>
      ),
    },
    {
      id: "checkWeb",
      label: "CheckIn Web",
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label="CheckIn Web"
            placeholder={`Buscar CheckIn Web`}
            id={`table-filter`}
            onClear={() => {}}
            value={valueSearch.checkWeb}
            onChange={(e) => handleFilterChange("checkWeb", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "feePC",
      label: t("header.feePCLabel"),
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label={t("header.feePCLabel")}
            placeholder={`Buscar Cuota`}
            id={`table-filter`}
            onClear={() => {}}
            value={valueSearch.feePC}
            onChange={(e) => handleFilterChange("feePC", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "feePrint",
      label: t("header.feePrintLabel"),
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label={t("header.feePrintLabel")}
            placeholder={`Buscar Cuota`}
            id={`table-filter`}
            onClear={() => {}}
            value={valueSearch.feePrint}
            onChange={(e) => handleFilterChange("feePrint", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "timeByRole",
      label: t("header.time2"),
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label={t("header.time2")}
            placeholder={`Buscar ${t("header.time2")}`}
            id={`table-filter`}
            onClear={() => {}}
            value={valueSearch.timeByRole}
            onChange={(e) => handleFilterChange("timeByRole", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "category",
      label: t("header.category"),
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label={t("header.category")}
            placeholder={`Buscar ${t("header.category")}`}
            id={`table-filter`}
            onClear={() => {}}
            value={valueSearch.category}
            onChange={(e) => handleFilterChange("category", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "partner",
      label: `Partner`,
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label={`Partner`}
            placeholder={`${t("header.search")} Partner`}
            id={`table-filter`}
            onClear={() => {}}
            value={valueSearch.partner}
            onChange={(e) => handleFilterChange("partner", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "fund",
      label: `${t("header.fund")}`,
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label={`${t("header.fund")}`}
            placeholder={`${t("header.search")} ${t("header.fund")}`}
            id={`table-filter`}
            onClear={() => {}}
            value={valueSearch.fund}
            onChange={(e) => handleFilterChange("fund", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "fundHp",
      label: `${t("header.fundHP")}`,
      filter: (
        <div style={{ width: "100%" }}>
          <Search
            label={`${t("header.fundHP")}`}
            placeholder={`${t("header.search")} ${t("header.fundHP")}`}
            id={`table-filter`}
            onClear={() => {}}
            value={valueSearch.fundHp}
            onChange={(e) => handleFilterChange("fundHp", e!.toString())}
          />
        </div>
      ),
    },
    { id: "creationDate", label: t("header.createdDate") },
    { id: "modificationDate", label: t("header.modifiedDate") },
  ];

  const pagedData = tableData.slice(
    (currentPage - 1) * pageSize,
    (currentPage - 1) * pageSize + pageSize
  );

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLElement>,
    option: OptionInterface<number>
  ) => {
    setPageSize(option.value);
  };

  const paginationProps: TablePagination = {
    currentPage,
    onPageChange: handlePageChange,
    onPageSizeChange: handlePageSizeChange,
    pageSize,
    totalItems: tableData.length,
  };

  // Open, close and clear
  const openNewUser = () => {
    resetForm();
    resetValid();
    setOpenCreate(true);
  };

  const closeModalCreate = () => {
    setOpenCreate(false);
    resetForm();
  };

  const closeModalCreateUser = () => {
    resetSearch();
    getUsers();
    setOpenCreatedUserModal(false);
    resetForm();
  };

  const closeModalUpdateUser = () => {
    setOpenUpdatedUserModal(false);
  };

  const closeModalNotUpdateUser = () => {
    setOpenNotUpdateUserModal(false);
  };

  const closeModalUncreateUser = () => {
    setOpenUncreatedUserModal(false);
  };

  const closeModalUpdate = () => {
    setOpenUpdate(false);
  };

  const openModalCreatedUser = () => {
    resetSearch();
    setOpenCreatedUserModal(true);
    getUsers();
  };

  const openModalUncreatedUser = () => {
    setOpenUncreatedUserModal(true);
  };

  const openModalUpdatedUser = () => {
    resetSearch();
    setOpenUpdatedUserModal(true);
    getUsers();
  };

  const openModalNotUpdateUser = () => {
    setOpenNotUpdateUserModal(true);
  };

  const handleDeleteUser = () => {
    resetSearch();
    deleteUser(valueUserDelete);
    setDeleteModal(false);

    setTimeout(() => {
      getUsers();
    }, 500);
  };

  const handleChangeCheck = (
    formIn: any,
    setFormIn: React.Dispatch<React.SetStateAction<any>>,
    setFormValuesIn: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setFormIn((prevState: any) => ({
      ...prevState,
      CheckWeb: !formIn.CheckWeb,
    }));
    setFormValuesIn((prevState: any) => ({
      ...prevState,
      CheckWeb: !formIn.CheckWeb,
    }));
  };

  const handleChangeFeePCCheck = (
    formIn: any,
    setFormIn: React.Dispatch<React.SetStateAction<any>>,
    setFormValuesIn: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setFormIn((prevState: any) => ({
      ...prevState,
      FeePC: formIn.FeePC === 0 ? 1 : 0,
    }));
    setFormValuesIn((prevState: any) => ({
      ...prevState,
      FeePC: formIn.FeePC === 0 ? 1 : 0,
    }));
  };

  const handleChangeFeePrintCheck = (
    formIn: any,
    setFormIn: React.Dispatch<React.SetStateAction<any>>,
    setFormValuesIn: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setFormIn((prevState: any) => ({
      ...prevState,
      FeePrint: formIn.FeePrint === 0 ? 1 : 0,
    }));
    setFormValuesIn((prevState: any) => ({
      ...prevState,
      FeePrint: formIn.FeePrint === 0 ? 1 : 0,
    }));
  };

  return (
    <div>
      <div style={{ padding: "2%" }}>
        <div
          style={{
            padding: "1%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <h4>{t("header.userManagement")}</h4>
          <Button onClick={() => openNewUser()}>{t("header.newUser")}</Button>
        </div>

        {/* Modal Create */}
        <div>
          <Modal
            align="start"
            id="modal-create"
            show={openCreate}
            onClose={() => setOpenCreate(false)}
            footer={
              <ButtonGroup>
                <Button disabled={isButtonValid} onClick={submitHandlerCreate}>
                  {t("header.save")}
                </Button>
                <Button appearance="secondary" onClick={closeModalCreate}>
                  {t("header.cancel")}
                </Button>
              </ButtonGroup>
            }
            title={t("header.registerInformation")}
          >
            <Grid container spacing={2}>
              <Grid item xs={6} md={6}>
                <TextBox
                  id="name"
                  label={t("header.name")}
                  placeholder={t("header.name")}
                  onChange={(text: string) =>
                    changeHandlerName(
                      text,
                      setFormValues,
                      setHandleValidate,
                      setForm
                    )
                  }
                  value={formValues.Name}
                  required={handleValidate.Name}
                  helperText={helperTextName(formValues)}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <TextBox
                  id="lastname"
                  label={t("header.lastName")}
                  placeholder={t("header.lastName")}
                  onChange={(text: string) =>
                    changeHandlerLastName(
                      text,
                      setFormValues,
                      setHandleValidate,
                      setForm
                    )
                  }
                  value={formValues.LastName}
                  required={handleValidate.LastName}
                  helperText={helperTextLastName(formValues)}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <Select
                  clearIcon={false}
                  options={optionSelect.Country}
                  id="selectCountry"
                  label={t("header.country")}
                  placement="bottom"
                  helperTextVisibility="auto"
                  onChange={(selectedOption: SelectOption) =>
                    onChangeCountry(
                      selectedOption,
                      setFormValues,
                      setHandleValidate,
                      setForm
                    )
                  }
                  value={formValues.Country}
                  required={handleValidate.Country}
                  helperText={helperTextCountry(handleValidate)}
                  onSearch={(query: string) =>
                    handleSearch(
                      query,
                      "Country",
                      optionSelect.FilteredCountry,
                      setOptionSelect
                    )
                  }
                  searchDelay={500}
                  showSearch={true}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <TextBox
                  id="document"
                  label={t("header.document")}
                  placeholder={t("header.document")}
                  onChange={(text: string) =>
                    changeHandlerDocumentID(
                      text,
                      setFormValues,
                      setHandleValidate,
                      setForm
                    )
                  }
                  value={formValues.DocumentId}
                  maxLength={15}
                  required={handleValidate.Document}
                  helperText={helperTextDocumentID(formValues)}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <Select
                  clearIcon={false}
                  options={optionSelect.State}
                  id="selectState"
                  label={t("header.state")}
                  placement="bottom"
                  helperTextVisibility="auto"
                  onChange={(selectedOption: SelectOption) =>
                    onChangeState(
                      selectedOption,
                      setFormValues,
                      setHandleValidate,
                      setForm
                    )
                  }
                  value={formValues.State}
                  disabled={handleValidate.Country}
                  required={handleValidate.State}
                  helperText={helperTextState(handleValidate)}
                  onSearch={(query: string) =>
                    handleSearch(
                      query,
                      "State",
                      optionSelect.FilteredState,
                      setOptionSelect
                    )
                  }
                  searchDelay={500}
                  showSearch={true}
                />
              </Grid>

              <Grid item xs={6} md={6}>
                <Select
                  clearIcon={false}
                  options={optionSelect.City}
                  id="selectCity"
                  label={t("header.city")}
                  placement="bottom"
                  helperTextVisibility="auto"
                  onChange={(selectedOption: SelectOption) =>
                    onChangeCity(
                      selectedOption,
                      setFormValues,
                      setHandleValidate,
                      setForm
                    )
                  }
                  value={formValues.City}
                  disabled={handleValidate.State}
                  required={handleValidate.City}
                  helperText={helperTextCity(handleValidate)}
                  onSearch={(query: string) =>
                    handleSearch(
                      query,
                      "City",
                      optionSelect.FilteredCity,
                      setOptionSelect
                    )
                  }
                  searchDelay={500}
                  showSearch={true}
                />
              </Grid>

              <Grid item xs={6} md={6}>
                {/* <Tooltip
                  placement="bottom"
                  content={roleDescription}
                  id="tooltip"
                >
                  <IconInfo />
                </Tooltip> */}
                <Select
                  clearIcon={false}
                  options={optionSelect.Role}
                  id="selectRole"
                  label={t("header.role")}
                  placement="bottom"
                  helperTextVisibility="auto"
                  onChange={(selectedOption: SelectOption) =>
                    onChangeRole(
                      selectedOption,
                      setFormValues,
                      setHandleValidate,
                      setForm
                    )
                  }
                  value={formValues.Role}
                  required={handleValidate.Role}
                  helperText={helperTextRole(handleValidate)}
                  onSearch={(query: string) =>
                    handleSearch(
                      query,
                      "Role",
                      optionSelect.FilteredRole,
                      setOptionSelect
                    )
                  }
                  searchDelay={500}
                  showSearch={true}
                />
              </Grid>
              {showFieldsTimeAndCategory(formValues.Role[0]) && (
                <>
                  <Grid item xs={6} md={6}>
                    <Select
                      clearIcon={false}
                      options={optionSelect.Time}
                      id="selectTime"
                      label={t("header.time2")}
                      placement="bottom"
                      helperTextVisibility="auto"
                      onChange={(selectedOption: SelectOption) =>
                        onChangeTime(
                          selectedOption,
                          setFormValues,
                          setHandleValidate,
                          setForm
                        )
                      }
                      value={formValues.Time}
                      disabled={disableFieldsProductivity(formValues.Role[0])}
                      required={handleValidate.Time}
                      helperText={helperTexTime(handleValidate)}
                      onSearch={(query: string) =>
                        handleSearch(
                          query,
                          "Time",
                          optionSelect.FilteredTime,
                          setOptionSelect
                        )
                      }
                      searchDelay={500}
                      showSearch={true}
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Select
                      clearIcon={false}
                      options={optionSelect.Categories}
                      id="selectCategories"
                      label={t("header.categories")}
                      placement="bottom"
                      helperTextVisibility="auto"
                      required={handleValidate.Categories}
                      disabled={disableFieldsProductivity(formValues.Role[0])}
                      onChange={(selectedOption: SelectOption) =>
                        onChangeCategories(
                          selectedOption,
                          setFormValues,
                          setHandleValidate,
                          setForm
                        )
                      }
                      value={formValues.Categories}
                      onSearch={(query: string) =>
                        handleSearch(
                          query,
                          "Categories",
                          optionSelect.FilteredCategories,
                          setOptionSelect
                        )
                      }
                      searchDelay={500}
                      showSearch={true}
                    />
                  </Grid>
                </>
              )}

              {/* Fields fund for print */}
              {categorySelectedApplyForPrintFund(formValues.Categories[0]) && (
                <>
                  <Grid item xs={6} md={6}>
                    <Select
                      clearIcon={false}
                      options={optionSelect.Partner}
                      id="selectPartnerPrint"
                      label={labelPrint("Partner", formValues.Categories[0])}
                      placement="bottom"
                      helperTextVisibility="auto"
                      value={formValues.PartnerPrint}
                      onChange={(selectedOption: SelectOption) =>
                        onChangePartnerPrint(
                          selectedOption,
                          setFormValues,
                          setHandleValidate,
                          setForm
                        )
                      }
                      disabled={disablePartner(formValues)}
                      // disabled={false} // always is disabled for print fund his value is set by default
                      required={handleValidate.PartnerPrint}
                      helperText={helperTextModal(handleValidate.PartnerPrint)}
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Select
                      clearIcon={false}
                      options={optionSelect.Fund}
                      id="selectFundPrint"
                      label={labelPrint(
                        t("header.fund"),
                        formValues.Categories[0]
                      )}
                      placement="bottom"
                      helperTextVisibility="auto"
                      value={formValues.FundPrint}
                      onChange={(selectedOption: SelectOption) =>
                        onChangeFundPrint(
                          selectedOption,
                          setFormValues,
                          setHandleValidate,
                          setForm
                        )
                      }
                      disabled={disablePartner(formValues)}
                      // disabled={false} // always is disabled for print fund his value is set by default
                      required={handleValidate.FundPrint}
                      searchDelay={500}
                      showSearch={true}
                    />
                  </Grid>
                  {requireFundHP && (
                    <Grid item xs={6} md={6}>
                      <Select
                        clearIcon={false}
                        options={optionSelect.FundHP}
                        id="selectFundHpPrint"
                        label={labelPrint(
                          t("header.fundHP"),
                          formValues.Categories[0]
                        )}
                        placement="bottom"
                        helperTextVisibility="auto"
                        onChange={(selectedOption: SelectOption) =>
                          onChangeFundHpPrint(
                            selectedOption,
                            setFormValues,
                            setHandleValidate,
                            setForm
                          )
                        }
                        value={formValues.FundHpPrint}
                        required={handleValidate.FundHpPrint}
                        onSearch={(query: string) =>
                          handleSearch(
                            query,
                            "FundHP",
                            optionSelect.FilteredFundHP,
                            setOptionSelect
                          )
                        }
                        searchDelay={500}
                        showSearch={true}
                      />
                    </Grid>
                  )}
                </>
              )}
              {/* Fields fund for print */}

              {/* Fields fund for PC */}
              {categorySelectedApplyForPCFund(formValues.Categories[0]) && (
                <>
                  <Grid item xs={6} md={6}>
                    <Select
                      clearIcon={false}
                      options={optionSelect.Partner}
                      id="selectPartnerPC"
                      label={labelPC("Partner", formValues.Categories[0])}
                      placement="bottom"
                      helperTextVisibility="auto"
                      onChange={(selectedOption: SelectOption) =>
                        onChangePartnerPC(
                          selectedOption,
                          setFormValues,
                          setHandleValidate,
                          setForm
                        )
                      }
                      value={formValues.PartnerPC}
                      required={handleValidate.PartnerPC}
                      helperText={helperTextModal(handleValidate.PartnerPC)}
                      onSearch={(query: string) =>
                        handleSearch(
                          query,
                          "Partner",
                          optionSelect.FilteredPartner,
                          setOptionSelect
                        )
                      }
                      searchDelay={500}
                      showSearch={true}
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Select
                      clearIcon={false}
                      options={optionSelect.Fund}
                      id="selectFundPC"
                      label={labelPC(
                        t("header.fund"),
                        formValues.Categories[0]
                      )}
                      placement="bottom"
                      helperTextVisibility="auto"
                      onChange={(selectedOption: SelectOption) =>
                        onChangeFundPC(
                          selectedOption,
                          setFormValues,
                          setHandleValidate,
                          setForm
                        )
                      }
                      value={formValues.FundPC}
                      required={handleValidate.FundPC}
                      disabled={handleValidate.PartnerPC}
                      onSearch={(query: string) =>
                        handleSearch(
                          query,
                          "Fund",
                          optionSelect.FilteredFund,
                          setOptionSelect
                        )
                      }
                      searchDelay={500}
                      showSearch={true}
                    />
                  </Grid>
                  {requireFundHP && (
                    <Grid item xs={6} md={6}>
                      <Select
                        clearIcon={false}
                        options={optionSelect.FundHP}
                        id="selectFundHpPC"
                        label={labelPC(
                          t("header.fundHP"),
                          formValues.Categories[0]
                        )}
                        placement="bottom"
                        helperTextVisibility="auto"
                        onChange={(selectedOption: SelectOption) =>
                          onChangeFundHpPC(
                            selectedOption,
                            setFormValues,
                            setHandleValidate,
                            setForm
                          )
                        }
                        value={formValues.FundHpPC}
                        required={handleValidate.FundHpPC}
                        onSearch={(query: string) =>
                          handleSearch(
                            query,
                            "FundHP",
                            optionSelect.FilteredFundHP,
                            setOptionSelect
                          )
                        }
                        searchDelay={500}
                        showSearch={true}
                      />
                    </Grid>
                  )}
                </>
              )}
              {/* Fields fund for PC */}

              <Grid
                item
                xs={12}
                md={getSizeFieldPhoneNumber(formValues.Categories[0])}
              >
                <TextBox
                  id="phoneNumber"
                  label={t("header.phoneNumber")}
                  placeholder={t("header.phoneNumber")}
                  onChange={(text: string) =>
                    changeHandlerPhone(
                      text,
                      setFormValues,
                      setHandleValidate,
                      setForm
                    )
                  }
                  maxLength={25}
                  value={formValues.Phone}
                  required={handleValidate.Phone}
                  helperText={helperTexPhone(formValues)}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <TextBox
                  id="email"
                  label={t("header.email")}
                  placeholder={t("header.email")}
                  onChange={(text: string) =>
                    changeHandlerEmail(
                      text,
                      setFormValues,
                      setHandleValidate,
                      setForm
                    )
                  }
                  type={"email"}
                  value={formValues.Email}
                  required={handleValidate.Email}
                  helperText={helperTexEmail(formValues)}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Select
                  clearIcon={false}
                  options={optionSelect.Supervisor}
                  id="selectSupervisor"
                  label={t("header.supervisor")}
                  placement="bottom"
                  helperTextVisibility="auto"
                  onChange={(selectedOption: SelectOption) =>
                    onChangeSupervisor(
                      selectedOption,
                      setFormValues,
                      setHandleValidate,
                      setForm
                    )
                  }
                  value={formValues.Supervisor}
                  disabled={disableSupervisor(formValues)}
                  required={handleValidate.Supervisor}
                  helperText={helperTexSupervisor(handleValidate)}
                  onSearch={(query: string) =>
                    handleSearch(
                      query,
                      "Supervisor",
                      optionSelect.FilteredSupervisor,
                      setOptionSelect
                    )
                  }
                  searchDelay={500}
                  showSearch={true}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Select
                  clearIcon={false}
                  options={optionSelect.Coordinator}
                  id="selectCoordinator"
                  label={t("header.coordinator")}
                  placement="bottom"
                  helperTextVisibility="auto"
                  onChange={(selectedOption: SelectOption) =>
                    onChangeCoordinator(
                      selectedOption,
                      setFormValues,
                      setHandleValidate,
                      setForm
                    )
                  }
                  value={formValues.Coordinator}
                  disabled={disableCoordinator(formValues)}
                  required={handleValidate.Coordinador}
                  helperText={helperTexSupervisor(handleValidate)}
                  onSearch={(query: string) =>
                    handleSearch(
                      query,
                      "Coordinator",
                      optionSelect.FilteredCoordinator,
                      setOptionSelect
                    )
                  }
                  searchDelay={500}
                  showSearch={true}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Checkbox
                  id={"checkbox"}
                  key={"checkboxKey"}
                  label={t("modal.questionCheckIn")}
                  checked={formValues.CheckWeb}
                  onChange={() =>
                    handleChangeCheck(form, setForm, setFormValues)
                  }
                />
              </Grid>
              {showFeeFields(formValues.Role[0]) && (
                <>
                  <Grid item xs={12} md={12}>
                    <Checkbox
                      id={"checkbox"}
                      key={"FeePCKey"}
                      label={t("header.feePC")}
                      checked={formValues.FeePC === 1}
                      onChange={() =>
                        handleChangeFeePCCheck(form, setForm, setFormValues)
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Checkbox
                      id={"checkbox"}
                      key={"FeePrintKey"}
                      label={t("header.feePrint")}
                      checked={formValues.FeePrint === 1}
                      onChange={() =>
                        handleChangeFeePrintCheck(form, setForm, setFormValues)
                      }
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Modal>

          {/* Modal Update */}
          <Modal
            align="start"
            id="modalUpdate"
            show={openUpdate}
            onClose={() => setOpenUpdate(false)}
            footer={
              <ButtonGroup>
                <Button
                  disabled={isButtonValidUpdate}
                  onClick={submitHandlerUpdate}
                >
                  {t("header.update")}
                </Button>
                <Button appearance="secondary" onClick={closeModalUpdate}>
                  {t("header.cancel")}
                </Button>
              </ButtonGroup>
            }
            title={t("header.registerInformation")}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextBox
                  id="nameUpdate"
                  label={t("header.name")}
                  placeholder={t("header.name")}
                  onChange={(text: string) =>
                    changeHandlerName(
                      text,
                      setFormValuesUpdate,
                      setHandleValidateUpdate,
                      setFormUpdate
                    )
                  }
                  value={formValuesUpdate.Name}
                  required={true}
                  helperText={helperTextName(formValuesUpdate)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextBox
                  id="lastnameUpdate"
                  label={t("header.lastName")}
                  placeholder={t("header.lastName")}
                  onChange={(text: string) =>
                    changeHandlerLastName(
                      text,
                      setFormValuesUpdate,
                      setHandleValidateUpdate,
                      setFormUpdate
                    )
                  }
                  value={formValuesUpdate.LastName}
                  required={true}
                  helperText={helperTextLastName(formValuesUpdate)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Select
                  clearIcon={false}
                  options={optionSelect.Country}
                  id="selectCountryUpdate"
                  label={t("header.country")}
                  placement="bottom"
                  helperTextVisibility="auto"
                  onChange={(selectedOption: SelectOption) =>
                    onChangeCountry(
                      selectedOption,
                      setFormValuesUpdate,
                      setHandleValidateUpdate,
                      setFormUpdate
                    )
                  }
                  value={formValuesUpdate.Country}
                  required={true}
                  helperText={helperTextCountry(handleValidateUpdate)}
                  onSearch={(query: string) =>
                    handleSearch(
                      query,
                      "Country",
                      optionSelect.FilteredCountry,
                      setOptionSelect
                    )
                  }
                  searchDelay={500}
                  showSearch={true}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Select
                  clearIcon={false}
                  options={optionSelect.State}
                  id="selectStateUpdate"
                  label={t("header.state")}
                  placement="bottom"
                  helperTextVisibility="auto"
                  onChange={(selectedOption: SelectOption) =>
                    onChangeState(
                      selectedOption,
                      setFormValuesUpdate,
                      setHandleValidateUpdate,
                      setFormUpdate
                    )
                  }
                  value={formValuesUpdate.State}
                  disabled={handleValidateUpdate.Country}
                  required={true}
                  helperText={helperTextState(handleValidateUpdate)}
                  onSearch={(query: string) =>
                    handleSearch(
                      query,
                      "State",
                      optionSelect.FilteredState,
                      setOptionSelect
                    )
                  }
                  searchDelay={500}
                  showSearch={true}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Select
                  clearIcon={false}
                  options={optionSelect.City}
                  id="selectCityUpdate"
                  label={t("header.city")}
                  placement="bottom"
                  helperTextVisibility="auto"
                  onChange={(selectedOption: SelectOption) =>
                    onChangeCity(
                      selectedOption,
                      setFormValuesUpdate,
                      setHandleValidateUpdate,
                      setFormUpdate
                    )
                  }
                  value={formValuesUpdate.City}
                  helperText={helperTextCity(handleValidateUpdate)}
                  disabled={handleValidateUpdate.State}
                  onSearch={(query: string) =>
                    handleSearch(
                      query,
                      "City",
                      optionSelect.FilteredCity,
                      setOptionSelect
                    )
                  }
                  searchDelay={500}
                  showSearch={true}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextBox
                  id="documentUpdate"
                  label={t("header.document")}
                  placeholder={t("header.document")}
                  onChange={(text: string) =>
                    changeHandlerDocumentID(
                      text,
                      setFormValuesUpdate,
                      setHandleValidateUpdate,
                      setFormUpdate
                    )
                  }
                  value={formValuesUpdate.DocumentId}
                  required={true}
                  helperText={helperTextDocumentID(formValuesUpdate)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Select
                  clearIcon={false}
                  options={optionSelect.Role}
                  id="selectRoleUpdate"
                  label={t("header.role")}
                  placement="bottom"
                  helperTextVisibility="auto"
                  onChange={(selectedOption: SelectOption) =>
                    onChangeRole(
                      selectedOption,
                      setFormValuesUpdate,
                      setHandleValidateUpdate,
                      setFormUpdate
                    )
                  }
                  value={formValuesUpdate.Role}
                  required={true}
                  helperText={helperTextRole(handleValidateUpdate)}
                  onSearch={(query: string) =>
                    handleSearch(
                      query,
                      "Role",
                      optionSelect.FilteredRole,
                      setOptionSelect
                    )
                  }
                  searchDelay={500}
                  showSearch={true}
                />
              </Grid>

              {showFieldsTimeAndCategory(formValuesUpdate.Role[0]) && (
                <>
                  <Grid item xs={12} md={6}>
                    <Select
                      clearIcon={false}
                      options={optionSelect.Time}
                      id="selectRoleUpdate"
                      label={t("header.time2")}
                      placement="bottom"
                      helperTextVisibility="auto"
                      onChange={(selectedOption: SelectOption) =>
                        onChangeTime(
                          selectedOption,
                          setFormValuesUpdate,
                          setHandleValidateUpdate,
                          setFormUpdate
                        )
                      }
                      value={formValuesUpdate.Time}
                      disabled={disableFieldsProductivity(
                        formValuesUpdate.Role[0]
                      )}
                      required={handleValidateUpdate.Time}
                      helperText={helperTexTime(handleValidateUpdate)}
                      onSearch={(query: string) =>
                        handleSearch(
                          query,
                          "Time",
                          optionSelect.FilteredTime,
                          setOptionSelect
                        )
                      }
                      searchDelay={500}
                      showSearch={true}
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Select
                      clearIcon={false}
                      options={optionSelect.Categories}
                      id="selectCategoriesUpdate"
                      label={t("header.categories")}
                      placement="bottom"
                      helperTextVisibility="auto"
                      onChange={(selectedOption: SelectOption) =>
                        onChangeCategories(
                          selectedOption,
                          setFormValuesUpdate,
                          setHandleValidateUpdate,
                          setFormUpdate
                        )
                      }
                      value={formValuesUpdate.Categories}
                      required={handleValidateUpdate.Categories}
                      disabled={disableFieldsProductivity(
                        formValuesUpdate.Role[0]
                      )}
                      onSearch={(query: string) =>
                        handleSearch(
                          query,
                          "Categories",
                          optionSelect.FilteredCategories,
                          setOptionSelect
                        )
                      }
                      searchDelay={500}
                      showSearch={true}
                    />
                  </Grid>
                </>
              )}

              {/* Fields fund for print */}
              {categorySelectedApplyForPrintFund(
                formValuesUpdate.Categories[0]
              ) && (
                // aqui
                <>
                  <Grid item xs={12} md={6}>
                    <Select
                      clearIcon={false}
                      options={optionSelect.Partner}
                      id="selectPartnerPrintUpdate"
                      label={labelPrint(
                        "Partner",
                        formValuesUpdate.Categories[0]
                      )}
                      placement="bottom"
                      helperTextVisibility="auto"
                      value={formValuesUpdate.PartnerPrint}
                      required={handleValidateUpdate.PartnerPrint}
                      helperText={helperTextModal(
                        handleValidateUpdate.PartnerPrint
                      )}
                      // disabled={true} // always is disabled for print fund his value is set by default
                      onChange={(selectedOption: SelectOption) =>
                        onChangePartnerPrint(
                          selectedOption,
                          setFormValuesUpdate,
                          setHandleValidateUpdate,
                          setFormUpdate
                        )
                      }
                      disabled={disablePartner(formValues)}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Select
                      clearIcon={false}
                      options={optionSelect.Fund}
                      id="selectFundPrintUpdate"
                      label={labelPrint(
                        t("header.fund"),
                        formValuesUpdate.Categories[0]
                      )}
                      placement="bottom"
                      helperTextVisibility="auto"
                      value={formValuesUpdate.FundPrint}
                      // disabled={true} // always is disabled for print fund his value is set by default
                      required={handleValidateUpdate.FundPrint}
                      onChange={(selectedOption: SelectOption) =>
                        onChangeFundPrint(
                          selectedOption,
                          setFormValuesUpdate,
                          setHandleValidateUpdate,
                          setFormUpdate
                        )
                      }
                      disabled={disablePartner(formValues)}
                    />
                  </Grid>
                  {requireFundHP && (
                    <Grid item xs={6} md={6}>
                      <Select
                        clearIcon={false}
                        options={optionSelect.FundHP}
                        id="selectFundHpPrintUpdate"
                        label={labelPrint(
                          t("header.fundHP"),
                          formValuesUpdate.Categories[0]
                        )}
                        placement="bottom"
                        helperTextVisibility="auto"
                        onChange={(selectedOption: SelectOption) =>
                          onChangeFundHpPrint(
                            selectedOption,
                            setFormValuesUpdate,
                            setHandleValidateUpdate,
                            setFormUpdate
                          )
                        }
                        value={formValuesUpdate.FundHpPrint}
                        required={handleValidateUpdate.FundHpPrint}
                        onSearch={(query: string) =>
                          handleSearch(
                            query,
                            "FundHP",
                            optionSelect.FilteredFundHP,
                            setOptionSelect
                          )
                        }
                        searchDelay={500}
                        showSearch={true}
                      />
                    </Grid>
                  )}
                </>
              )}
              {/* Fields fund for print */}

              {/* Fields fund for PC */}
              {categorySelectedApplyForPCFund(
                formValuesUpdate.Categories[0]
              ) && (
                <>
                  <Grid item xs={12} md={6}>
                    <Select
                      clearIcon={false}
                      options={optionSelect.Partner}
                      id="selectPartnerPCUpdate"
                      label={labelPC("Partner", formValuesUpdate.Categories[0])}
                      placement="bottom"
                      helperTextVisibility="auto"
                      onChange={(selectedOption: SelectOption) =>
                        onChangePartnerPC(
                          selectedOption,
                          setFormValuesUpdate,
                          setHandleValidateUpdate,
                          setFormUpdate
                        )
                      }
                      value={formValuesUpdate.PartnerPC}
                      required={handleValidateUpdate.PartnerPC}
                      helperText={helperTextModal(
                        handleValidateUpdate.PartnerPC
                      )}
                      onSearch={(query: string) =>
                        handleSearch(
                          query,
                          "Partner",
                          optionSelect.FilteredPartner,
                          setOptionSelect
                        )
                      }
                      searchDelay={500}
                      showSearch={true}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Select
                      clearIcon={false}
                      options={optionSelect.Fund}
                      id="selectFundPCUpdate"
                      label={labelPC(
                        t("header.fund"),
                        formValuesUpdate.Categories[0]
                      )}
                      placement="bottom"
                      helperTextVisibility="auto"
                      onChange={(selectedOption: SelectOption) =>
                        onChangeFundPC(
                          selectedOption,
                          setFormValuesUpdate,
                          setHandleValidateUpdate,
                          setFormUpdate
                        )
                      }
                      value={formValuesUpdate.FundPC}
                      required={handleValidateUpdate.FundPC}
                      disabled={handleValidateUpdate.PartnerPC}
                      onSearch={(query: string) =>
                        handleSearch(
                          query,
                          "Fund",
                          optionSelect.FilteredFund,
                          setOptionSelect
                        )
                      }
                      searchDelay={500}
                      showSearch={true}
                    />
                  </Grid>
                  {requireFundHP && (
                    <Grid item xs={6} md={6}>
                      <Select
                        clearIcon={false}
                        options={optionSelect.FundHP}
                        id="selectFundHpPCUpdate"
                        label={labelPC(
                          t("header.fundHP"),
                          formValuesUpdate.Categories[0]
                        )}
                        placement="bottom"
                        helperTextVisibility="auto"
                        onChange={(selectedOption: SelectOption) =>
                          onChangeFundHpPC(
                            selectedOption,
                            setFormValuesUpdate,
                            setHandleValidateUpdate,
                            setFormUpdate
                          )
                        }
                        value={formValuesUpdate.FundHpPC}
                        required={handleValidateUpdate.FundHpPC}
                        onSearch={(query: string) =>
                          handleSearch(
                            query,
                            "FundHP",
                            optionSelect.FilteredFundHP,
                            setOptionSelect
                          )
                        }
                        searchDelay={500}
                        showSearch={true}
                      />
                    </Grid>
                  )}
                </>
              )}
              <Grid
                item
                xs={12}
                md={getSizeFieldPhoneNumber(formValuesUpdate.Categories[0])}
              >
                <TextBox
                  id="phoneNumberUpdate"
                  label={t("header.phoneNumber")}
                  placeholder={t("header.phoneNumber")}
                  onChange={(text: string) =>
                    changeHandlerPhone(
                      text,
                      setFormValuesUpdate,
                      setHandleValidateUpdate,
                      setFormUpdate
                    )
                  }
                  value={formValuesUpdate.Phone}
                  helperText={helperTexPhone(formValuesUpdate)}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <TextBox
                  id="emailUpdate"
                  label={t("header.email")}
                  placeholder={t("header.email")}
                  onChange={(text: string) =>
                    changeHandlerEmail(
                      text,
                      setFormValuesUpdate,
                      setHandleValidateUpdate,
                      setFormUpdate
                    )
                  }
                  value={formValuesUpdate.Email}
                  required={true}
                  type={"email"}
                  helperText={helperTexEmail(formValuesUpdate)}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Select
                  clearIcon={false}
                  options={optionSelect.Supervisor}
                  id="selectSupervisorUpdate"
                  label={t("header.supervisor")}
                  placement="bottom"
                  helperTextVisibility="auto"
                  onChange={(selectedOption: SelectOption) =>
                    onChangeSupervisor(
                      selectedOption,
                      setFormValuesUpdate,
                      setHandleValidateUpdate,
                      setFormUpdate
                    )
                  }
                  value={formValuesUpdate.Supervisor}
                  disabled={disableSupervisor(formValuesUpdate)}
                  required={true}
                  helperText={helperTexSupervisor(handleValidateUpdate)}
                  onSearch={(query: string) =>
                    handleSearch(
                      query,
                      "Supervisor",
                      optionSelect.FilteredSupervisor,
                      setOptionSelect
                    )
                  }
                  searchDelay={500}
                  showSearch={true}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Select
                  clearIcon={false}
                  options={optionSelect.Coordinator}
                  id="selectCoordinatorUpdate"
                  label={t("header.coordinator")}
                  placement="bottom"
                  helperTextVisibility="auto"
                  onChange={(selectedOption: SelectOption) =>
                    onChangeCoordinator(
                      selectedOption,
                      setFormValuesUpdate,
                      setHandleValidateUpdate,
                      setFormUpdate
                    )
                  }
                  value={formValuesUpdate.Coordinator}
                  disabled={disableCoordinator(formValuesUpdate)}
                  required={handleValidateUpdate.Coordinador}
                  helperText={helperTexSupervisor(handleValidateUpdate)}
                  onSearch={(query: string) =>
                    handleSearch(
                      query,
                      "Coordinator",
                      optionSelect.FilteredCoordinator,
                      setOptionSelect
                    )
                  }
                  searchDelay={500}
                  showSearch={true}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Checkbox
                  id={"checkboxUpdate"}
                  key={"checkboxUpdateKey"}
                  label={t("modal.questionCheckIn")}
                  checked={formValuesUpdate.CheckWeb}
                  onChange={() =>
                    handleChangeCheck(
                      formUpdate,
                      setFormUpdate,
                      setFormValuesUpdate
                    )
                  }
                />
              </Grid>
              {showFeeFields(formValuesUpdate.Role[0]) && (
                <>
                  <Grid item xs={12} md={12}>
                    <Checkbox
                      id={"checkboxUpdate"}
                      key={"feePCKey"}
                      label={t("header.feePC")}
                      checked={Boolean(formValuesUpdate.FeePC)}
                      onChange={() =>
                        handleChangeFeePCCheck(
                          formUpdate,
                          setFormUpdate,
                          setFormValuesUpdate
                        )
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Checkbox
                      id={"checkboxUpdate"}
                      key={"feePrintKey"}
                      label={t("header.feePrint")}
                      checked={Boolean(formValuesUpdate.FeePrint)}
                      onChange={() =>
                        handleChangeFeePrintCheck(
                          formUpdate,
                          setFormUpdate,
                          setFormValuesUpdate
                        )
                      }
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Modal>

          {/* Created User Modal */}
          <ModalMessageUser
            setOpenCloseModal={setOpenCreatedUserModal}
            closeModalCreateUser={closeModalCreateUser}
            openModal={openCreatedUserModal}
            titleMessage={t("modal.message")}
            message={t("modal.userCreated")}
          />

          {/* Uncreated User Modal */}
          <ModalMessageUser
            setOpenCloseModal={setOpenUncreatedUserModal}
            closeModalCreateUser={closeModalUncreateUser}
            openModal={openUncreatedUserModal}
            titleMessage={t("modal.message")}
            message={t("modal.userNotCreated")}
          />

          {/* Modal Update Ok*/}
          <ModalMessageUser
            setOpenCloseModal={setOpenUpdatedUserModal}
            closeModalCreateUser={closeModalUpdateUser}
            openModal={openUpdatedUserModal}
            titleMessage={t("modal.message")}
            message={t("modal.updateInfo")}
          />

          {/* Modal Not Update*/}
          <ModalMessageUser
            setOpenCloseModal={setOpenNotUpdateUserModal}
            closeModalCreateUser={closeModalNotUpdateUser}
            openModal={openNotUpdateUserModal}
            titleMessage={t("modal.message")}
            message={t("modal.informationNotUpdated")}
          />

          {/* Modal Delete User Question*/}
          <Modal
            align="start"
            id="modal-id"
            show={openDeleteModal}
            onClose={() => setDeleteModal(false)}
            footer={
              <Group>
                <Button onClick={handleDeleteUser}>Si</Button>
                <Button
                  appearance="secondary"
                  onClick={() => setDeleteModal(false)}
                >
                  No
                </Button>
              </Group>
            }
            title={t("modal.warningTitle")}
          >
            <p>{t("modal.questionDelete")}</p>
          </Modal>

          <Card
            appearance="outlined"
            className="userManagementCard"
            content={
              <>
                <Table
                  className="userManagementTable"
                  behavior={{
                    type: "singlePage",
                  }}
                  pagination={paginationProps}
                  columnResize
                  showFilters={true}
                  loading={loading}
                  columns={columns}
                  data={pagedData}
                  loadingDataLength={10}
                  customNoItems={
                    <div className="customNoItems">
                      <div className="DivIconCustomNoItems">
                        <IconWarningAlt className="IconCustomNoItems" />
                      </div>
                      {t("header.noItemsFound")}
                    </div>
                  }
                />
              </>
            }
          />
        </div>
      </div>
    </div>
  );
}
